var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOthericon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.286,
    height: 21.287,
    viewBox: "0 0 21.286 21.287",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_475",
    "data-name": "Group 475",
    transform: "translate(-922.856 -13.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M933.493,13.8a10.643,10.643,0,1,1-10.637,10.589A10.649,10.649,0,0,1,933.493,13.8Zm.007,19.471a8.827,8.827,0,1,0-8.829-8.86A8.839,8.839,0,0,0,933.5,33.273Z",
    transform: "translate(0 0)",
    fill: "#30528b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M1079.356,168.49a1.823,1.823,0,1,1-1.82,1.839A1.831,1.831,0,0,1,1079.356,168.49Z",
    transform: "translate(-145.86 -145.867)",
    fill: "#30528b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M1166.462,170.331a1.819,1.819,0,0,1-1.817,1.808,1.822,1.822,0,1,1,0-3.645A1.817,1.817,0,0,1,1166.462,170.331Z",
    transform: "translate(-226.282 -145.871)",
    fill: "#30528b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M992.32,170.316a1.814,1.814,0,0,1,1.833-1.819,1.823,1.823,0,0,1-.007,3.645A1.817,1.817,0,0,1,992.32,170.316Z",
    transform: "translate(-65.503 -145.875)",
    fill: "#30528b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthericon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/other.icon.f956b70e8327484abd354d1d29168251.svg";
export { ForwardRef as ReactComponent };